module.exports = __webpack_public_path__ + "img/sprinkle-3.8c0afbc3.webp";